var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data.juryModalVisible
    ? _c("div", {}, [
        _c(
          "div",
          {
            staticClass: "modal fade juryModalChangeCategory show",
            attrs: {
              id: "juryModalChangeCategory",
              tabindex: "-1",
              role: "juryModalChangeCategory",
              "aria-labelledby": "juryModalChangeCategory"
            }
          },
          [
            _c(
              "div",
              {
                staticClass: "modal-dialog",
                attrs: { role: "juryModalChangeCategory" }
              },
              [
                _c("div", { staticClass: "modal-content" }, [
                  _c("div", { staticClass: "modal-header" }, [
                    _c(
                      "button",
                      {
                        staticClass: "close",
                        attrs: {
                          type: "button",
                          "data-dismiss": "juryModalChangeCategory",
                          "aria-label": "Close"
                        },
                        on: {
                          click: function($event) {
                            return _vm.closeModal()
                          }
                        }
                      },
                      [_c("span", { staticClass: "mdi mdi-close" })]
                    )
                  ]),
                  _c("div", { staticClass: "modal-body" }, [
                    _c("h2", { staticClass: "mb-5 text-center" }, [
                      _vm._v(_vm._s(_vm.trans("keep_it_up")))
                    ]),
                    _vm.getAllVoted()
                      ? _c("h4", { staticClass: "mb-5 text-center" }, [
                          _vm._v(
                            _vm._s(
                              _vm.trans("you_finished_voting_for_this_category")
                            )
                          )
                        ])
                      : _c("h4", { staticClass: "mb-5 text-center" }, [
                          _vm._v(
                            _vm._s(
                              _vm.trans(
                                "you_have_some_unvoted_projects_in_this_category_do_you_want_to_continue"
                              )
                            )
                          )
                        ]),
                    _vm.getAllVoted()
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "category-ok-image-container mb-5 text-center"
                          },
                          [
                            _c("img", {
                              staticClass: "category-ok-image",
                              attrs: {
                                src: "/images/life-challenge/finished.svg",
                                alt: ""
                              }
                            })
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "choose-category text-center mb-5" },
                      [
                        _c("SimpleDropdownComponent", {
                          attrs: {
                            dataSource: _vm.getCategories(),
                            displayProp: "name",
                            changeUrl: false
                          },
                          model: {
                            value: _vm.category,
                            callback: function($$v) {
                              _vm.category = $$v
                            },
                            expression: "category"
                          }
                        })
                      ],
                      1
                    ),
                    !_vm.getAllVoted()
                      ? _c("div", { staticClass: "row mb-5" }, [
                          _c("div", { staticClass: "col text-center" }, [
                            _c(
                              "button",
                              {
                                staticClass: "button type-1 ml-auto",
                                attrs: { type: "submit" },
                                on: {
                                  click: function($event) {
                                    return _vm.backToThisCategory()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.trans("back_to_this_category"))
                                )
                              ]
                            )
                          ])
                        ])
                      : _vm._e()
                  ])
                ])
              ]
            )
          ]
        ),
        _c("div", { staticClass: "modal-backdrop fade show" })
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }